module.exports = __webpack_public_path__ + "img/q5-1-4@2x.7bc048b1.png";